import './MonthSelection.css';
import React, { useEffect } from 'react';
import { Tab, TabGroup } from '@nike/eds'
import { useSelector, useDispatch } from 'react-redux';
import { changeMonth, findBatchesByMonth, selectActiveMonthOption, selectMonthOptions } from '../../shared/store/reducers/OverviewReducer';
import { StoreDispatch } from '../../shared/store/Store';
import { MonthOption } from '../../shared/Types';

export function MonthSelection() {
    const dispatch: StoreDispatch = useDispatch();
    const months: MonthOption[] = useSelector(selectMonthOptions);
    const activeMonthOption: MonthOption = useSelector(selectActiveMonthOption);

    useEffect(() => {
        dispatch(findBatchesByMonth(activeMonthOption));
    }, [dispatch, activeMonthOption]);

    const onChange = (id: string) => {
        const index = parseInt(id.replace('month-', ''));
        dispatch(changeMonth(months[index]));
    }
    
    const activeIndex = months.indexOf(activeMonthOption);

    const handleMonthChange = (e: any) => {
        e.stopPropagation();
        onChange(e.target.id);
    }


    return (
        <div id="month-tab-container">
            <TabGroup activeId={`month-${activeIndex}`} name="month-tab-selection" onChange={handleMonthChange}>
                {months.map((am, index) => <Tab id={`month-${index}`} key={index}>{`${am.year} - ${am.month.toString().padStart(2, '0')}`}</Tab>)}
            </TabGroup>
        </div>
    )
}